<template>
  <div class="tw:fixed tw:bottom-0 tw:md:right-10">
    <ChatWindow class="tw:relative tw:md:bottom-20 tw:right-0 tw:z-10 tw:md:z-auto" />
    <ChatEntryButton class="tw:fixed tw:bottom-5 tw:md:bottom-0 tw:right-5 tw:md:right-10" />
  </div>
</template>

<script setup>
import ChatEntryButton from '@/components/chatbot/ChatEntryButton.vue'
import ChatWindow from '@/components/chatbot/ChatWindow.vue'
</script>
